// The new self-service API answers errors with a plain-text body (the message the controller threw,
// e.g. "Unknown profile field: nope"); anything else - a dropped connection, a bare status - uses the
// screen's own text. This is the one place that convention lives, so the profile page and its edit
// form cannot drift apart.
const failureText = (err, fallback) => (typeof err.response?.data === 'string' && err.response.data
  ? err.response.data : fallback);

export default failureText;
